// ============================================
// Bộ lọc của màn góp ý -> query params của BE
// ============================================
// Tách khỏi component vì đây là chỗ DUY NHẤT dịch trạng thái UI sang tham số gửi
// đi, và nó chứa một quy tắc dễ vi phạm khi sửa vội (xem `open` bên dưới).

import type {
  FeedbackRatingValue,
  FeedbackStatus,
  FeedbackType,
  StaffFeedbackListParams,
} from '@conai/shared-types';

export interface FeedbackFilterState {
  /** Nút nhanh "Chỉ chưa xử lý" — map sang `open=true` của BE. */
  onlyOpen: boolean;
  /** Nhiều trạng thái cùng lúc; rỗng = không lọc theo trạng thái. */
  statuses: FeedbackStatus[];
  /** `''` = tất cả. */
  feedbackType: FeedbackType | '';
  /** `''` = tất cả. */
  rating: FeedbackRatingValue | '';
  /** `YYYY-MM-DD` (đúng định dạng `<input type="date">`), `''` = không giới hạn. */
  dateFrom: string;
  dateTo: string;
}

export const EMPTY_FEEDBACK_FILTERS: FeedbackFilterState = {
  onlyOpen: false,
  statuses: [],
  feedbackType: '',
  rating: '',
  dateFrom: '',
  dateTo: '',
};

export function isFeedbackFilterActive(filters: FeedbackFilterState): boolean {
  return (
    filters.onlyOpen ||
    filters.statuses.length > 0 ||
    filters.feedbackType !== '' ||
    filters.rating !== '' ||
    filters.dateFrom !== '' ||
    filters.dateTo !== ''
  );
}

/**
 * Dựng params cho `useStaffFeedbackList` (và, qua đó, cho cả `useStaffFeedbackSummary`).
 *
 * ⚠️ `open` VÀ `status` LOẠI TRỪ NHAU. `open: true` là LỐI TẮT của BE cho
 * `status=NEW,IN_REVIEW` kèm đổi thứ tự sắp xếp (cũ nhất trước — hàng đợi việc
 * phải làm). Gửi kèm `status` là chồng hai bộ lọc lên nhau: kết quả phụ thuộc
 * cách BE ưu tiên, và bảng sẽ trả về một tập không khớp với thứ người dùng vừa
 * bấm. Ở đây `onlyOpen` thắng, và UI có trách nhiệm nói rõ điều đó — xem
 * `FeedbackFilterBar`.
 *
 * Khoá nào không lọc thì KHÔNG được có trong object: `queryKey` dựng từ params,
 * nên `{ status: undefined }` và `{}` là hai cache entry khác nhau cho cùng một
 * câu hỏi.
 */
export function buildFeedbackListParams(
  filters: FeedbackFilterState,
  page: number,
  pageSize: number
): StaffFeedbackListParams {
  const params: StaffFeedbackListParams = { page, page_size: pageSize };

  if (filters.onlyOpen) {
    params.open = true;
  } else if (filters.statuses.length > 0) {
    params.status = filters.statuses;
  }

  if (filters.feedbackType) params.feedback_type = filters.feedbackType;
  if (filters.rating) params.rating = filters.rating;
  if (filters.dateFrom) params.date_from = filters.dateFrom;
  if (filters.dateTo) params.date_to = filters.dateTo;

  return params;
}
